<template>
  <el-tooltip class="item" effect="dark" content="Descargar" placement="top-start">
    <el-button @click="handleClick" :disabled="downloading" circle  size="small">
      <i class="fas fa-arrow-circle-down"></i>
    </el-button>
  </el-tooltip>
</template>

<script>
import http from '@/api/http'
export default {
  name: "DownloadButton",
  props: {
    roomId: {
      type: String,
      required: true
    },
    messageId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      downloading: false
    }
  },
  methods: {
    async handleClick () {
      this.downloading = true
      try {
        const response = await http.get(`/chat/${this.roomId}/messages/${this.messageId}/download`, { responseType: 'blob' })
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        const disposition = response.headers['content-disposition'] || '';
        const fileNameMatch = disposition.match(/filename="?(.+)"?/);
        a.download = fileNameMatch ? fileNameMatch[1].replace("\\", "").replace('"', '') : 'archivo.descargado';

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch {
        this.$message.error("Error downloading file")
      } finally {
        this.downloading = false
      }
    }
  }
};
</script>